export default class ApiError extends Error {
  constructor (code, message, response) {
    const groups = message.match(/(.*?)\n(.*)/) || []
    message = groups[1] || message
    super(message)
    this.code = code
    this.description = groups[2]
    this.response = response
  }
}
